namespace RioERP.Reports {
    export interface FranchiseeOutstandingForm {
        OrderId: Serenity.IntegerEditor;
        OrderOrderDate: Serenity.DateTimeEditor;
        OrderProductsId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        SharePercentage: Serenity.DecimalEditor;
        OrderProdutcsGrossAmount: Serenity.DecimalEditor;
        ShareAmount: Serenity.DecimalEditor;
        Quantity: Serenity.IntegerEditor;
        SettelmentId: Serenity.IntegerEditor;
        ESettelementStatus: Serenity.EnumEditor;
        FranchiseeEmail: Serenity.EmailEditor;
        FranchiseeMobile: Serenity.StringEditor;
        TotalShare: Serenity.DecimalEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class FranchiseeOutstandingForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.FranchiseeOutstanding';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeOutstandingForm.init)  {
                FranchiseeOutstandingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateTimeEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.EnumEditor;
                var w5 = s.EmailEditor;
                var w6 = s.StringEditor;
                var w7 = s.BooleanEditor;

                Q.initFormType(FranchiseeOutstandingForm, [
                    'OrderId', w0,
                    'OrderOrderDate', w1,
                    'OrderProductsId', w2,
                    'FranchiseeId', w2,
                    'SharePercentage', w3,
                    'OrderProdutcsGrossAmount', w3,
                    'ShareAmount', w3,
                    'Quantity', w0,
                    'SettelmentId', w0,
                    'ESettelementStatus', w4,
                    'FranchiseeEmail', w5,
                    'FranchiseeMobile', w6,
                    'TotalShare', w3,
                    'IsActive', w7
                ]);
            }
        }
    }
}
